import AjaxHelper from "./../_Base/AjaxHelper";

export default class ApiBase {
    static doAjaxCall(methodName, url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback) {
        
        return AjaxHelper[methodName](url, input, apiKey, apiSecret, successCallback,
                function (status, statusText) {
                    if (errorCallback) {
                        errorCallback(status, statusText);
                    }
                },
                function () {
                    if (alwaysCallback) {
                        alwaysCallback();
                    }
                });
    }
    static getData(url, input, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.doAjaxCall("get", url, input, null, null, successCallback, errorCallback, alwaysCallback);
    }
    static postData(url, input, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.doAjaxCall("post", url, input, null, null, successCallback, errorCallback, alwaysCallback);
    }

    static putData(url, input, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.doAjaxCall("put", url, input, null, null, successCallback, errorCallback, alwaysCallback, true);
    }

    static deleteData(url, input, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.doAjaxCall("delete", url, input, null, null, successCallback, errorCallback, alwaysCallback, true);
    }

    static getDataWithApiKey(url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.doAjaxCall("get", url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback);
    }
    static postDataWithApiKey(url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.doAjaxCall("post", url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback);
    }

    static putDataWithApiKey(url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.doAjaxCall("put", url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback, true);
    }

    static deleteDataWithApiKey(url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.doAjaxCall("delete", url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback, true);
    }
}
